export default __webpack_public_path__ + "static/media/worning.e0e344da.svg";